export const QC_REQUIRED_FIELDS_OPU_SEARCH = [
  'tog_qc_cellstrainer',
  'tog_qc_fiftymllotno',
  'tog_qc_fiftymltubetype',
  'tog_qc_thirtymlsyringe',
  'tog_qc_tenmlsyringe',
  'tog_qc_opuflush',
  'tog_qc_opuflushdate',
  'tog_qc_matdate',
  'tog_qc_hepdate',
  'tog_qc_rinsemedialotdate',
  'tog_qc_incubatorno',
  'tog_qcairqualityint',
  'tog_qc_slide_warmer',
  'tog_qc_tokai_hit',
  'tog_qc_water_bath_temperature',
];

export const FARBRO_LOCATIONS = ['TO EXUM', 'TO HARTLEY'];

export const FERT_PLAN_OPTIONS = [
  { label: 'DID NOT ASPIRATE', value: 'DID_NOT_ASPIRATE' },
  { label: 'DO NOT FERT', value: 'DO_NOT_FERT' },
  { label: 'FERT', value: 'FERT' },
  { label: 'POOL', value: 'POOL' },
];

export const OPU_SEARCH_COMMENT_OPTIONS = [
  'Blood Clot',
  'Clogged Filter',
  'Fecal Contamination',
  'Mucous',
  'Primary Follicles',
  'Slow Draining Filter',
  'Split',
];
